import { openDB } from 'idb';

const DB_NAME = 'job_guide';
const DB_VERSION = 1;
const STORE = 'viewed_jobs';

function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      const store = db.createObjectStore(STORE, { keyPath: 'id' });
      store.createIndex('viewed_at', 'viewed_at');
    },
  });
}

function readSnapshotFromDOM() {
  const el = document.querySelector('#js-viewed-job-source');
  if (!el) return null;
  const id = Number(el.dataset.jobId);
  if (!id) return null;
  return {
    id: id,
    shop_name: el.dataset.shopName || '',
    url: el.dataset.url || '',
  };
}

async function recordJob(snapshot) {
  const db = await getDB();
  const tx = db.transaction(STORE, 'readwrite');
  const record = Object.assign({}, snapshot, { viewed_at: Date.now() });
  await tx.store.put(record);
  await tx.done;
}

async function cleanupOldRecords() {
  const db = await getDB();
  const tx = db.transaction(STORE, 'readwrite');
  const cutoff = Date.now() - 14 * 24 * 60 * 60 * 1000;
  const MAX = 10;

  const all = await tx.store.index('viewed_at').getAll();
  all.sort((a, b) => b.viewed_at - a.viewed_at);

  // Queue all deletes without awaiting each one individually — prevents
  // IDB transaction auto-commit between loop iterations.
  const deletes = [];
  for (let i = 0; i < all.length; i++) {
    if (i >= MAX || all[i].viewed_at < cutoff) {
      deletes.push(tx.store.delete(all[i].id));
    }
  }
  await Promise.all(deletes);
  await tx.done;
}

async function recordCurrentJob() {
  const snap = readSnapshotFromDOM();
  if (!snap) return;
  try {
    await recordJob(snap);
    await cleanupOldRecords();
  } catch (e) {
    // Safari private mode and some embedded browsers reject IDB writes.
    // Fail silently — feature is non-essential.
    console.warn('viewed_jobs: failed to record', e);
  }
}

async function getAllJobsByRecent() {
  const db = await getDB();
  const tx = db.transaction(STORE, 'readonly');
  const idx = tx.store.index('viewed_at');
  const items = [];
  let cursor = await idx.openCursor(null, 'prev'); // DESC = newest first
  while (cursor && items.length < 10) {
    items.push(cursor.value);
    cursor = await cursor.continue();
  }
  await tx.done;
  return items;
}

function escapeHtml(s) {
  if (s == null) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function itemHtml(job) {
  return `<li><a href="${escapeHtml(job.url)}"><span class="viewed-job-label">${escapeHtml(job.shop_name || '')}</span></a></li>`;
}

async function renderHistory() {
  const lists = document.querySelectorAll('.js-viewed-job-list');
  if (!lists.length) return;

  let items = [];
  try {
    items = await getAllJobsByRecent();
  } catch (e) {
    console.warn('viewed_jobs: failed to load', e);
    return;
  }

  const html = items.map(itemHtml).join('');
  lists.forEach((list) => {
    list.innerHTML = html;
    const block = list.closest('.js-viewed-block');
    if (block) block.style.display = items.length ? '' : 'none';
  });
}

$(function() {
  recordCurrentJob();
  renderHistory();
});
